module.exports = __webpack_public_path__ + "static/media/sees_logo_gold.8c774d4c.png";